module.exports = "settings"